// AI生图
const jmRoutes = Array.from({ length: 12 }, (_, i) => ({
  path: `AIGeneratedImages/jm/index${i + 1}`,
  name: `AIGeneratedImages/jm/Index${i + 1}`,
  component: () => import(`@/views/smartLife/AIGeneratedImages/jm/index${i + 1}.vue`)
}))
const branch1jmRoutes = Array.from({ length: 5 }, (_, i) => ({
  path: `AIGeneratedImages/jm/branch1/index${i + 1}`,
  name: `AIGeneratedImages/jm/branch1/Index${i + 1}`,
  component: () => import(`@/views/smartLife/AIGeneratedImages/jm/branch1/index${i + 1}.vue`)
}))

const dbRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `AIGeneratedImages/db/index${i + 1}`,
  name: `AIGeneratedImages/db/Index${i + 1}`,
  component: () => import(`@/views/smartLife/AIGeneratedImages/db/index${i + 1}.vue`)
}))
const branch1DbRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `AIGeneratedImages/db/branch1/index${i + 1}`,
  name: `AIGeneratedImages/db/branch1/Index${i + 1}`,
  component: () => import(`@/views/smartLife/AIGeneratedImages/db/branch1/index${i + 1}.vue`)
}))

import AIGeneratedImagesIndex from '@/views/smartLife/AIGeneratedImages/index'



export default {
  path: '/smartLife',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'AIGeneratedImages/index',
        name: 'AIGeneratedImagesIndex',
        component: AIGeneratedImagesIndex
      },
    // AI生图，开始
    ...jmRoutes,
    ...branch1jmRoutes,
    ...dbRoutes,
    ...branch1DbRoutes,
    // AI生图，结束


  ],
};
